import { Box, Button, Text, Input, Select, Tabs, TabList, Tab, TabPanels, TabPanel, FormControl, useToast } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderText } from "../../redux/actions/actions";
import { loadSchedule,addExamSchedule, getClasses, getDegrees, getExamSchedules, getSpecifications, loadSessionTimings, loadSubjects, updateExamSchedule } from '../../redux/api_calls/apiCalls'
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import ScheduleRow from "./ScheduleRow";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { deleteExamSchedule } from './../../redux/api_calls/apiCalls';
import ViewScheduleRow from './ViewScheduleRow';

export default function Schedule() {
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const headerText = useSelector(state => state.headerState.headerText)
    const subjectsData = useSelector(state => state.subjectsState.subjectsData)
    const sessionTimingsData = useSelector(state => state.sessionTimingsState.sessionTimingsData)
    const classesData = useSelector(state => state.classesState.classesData)
    const [selectedValue, setSelectedValue] = useState('5')
    const [selectedClassValue, setSelectedClassValue] = useState('0')
    const [selectedDegreeValue, setSelectedDegreeValue] = useState('0')
    const [selectedSpecificationValue, setSelectedSpecificationValue] = useState('0')
    const [sessionTimings, setSessionTimings] = useState([])
    const dispatch = useDispatch()
    const daysRef = useRef()
    const classRef = useRef()
    const degreeRef = useRef()
    const specRef = useRef()
      const sessionsRef = useRef()
    const [startDate, setStartDate] = useState('')
    const [headers, setHeaders] = useState([])
    const [schedulerDimensions, setSchedulerDimensions] = useState(null);
    const { monthData, isMonthLoading } = useSelector(state => state.calendarMonthState)

    const [disableFieldId, setdisableFieldId] = useState('');
    // const [selectedTabName, setselectedTabName] = useState("Class Schedule");

    const degreeState = useSelector(state => state.degreeState.degreeData);

    const specificationState = useSelector(state => state.specificationState.specificationData);
    const examSchedulespecificationState = useSelector(state => state.specificationState.specificationData);

    const examScheduleState = useSelector(state => state.examScheduleState.getExamSchedules);
    const toast = useToast();
    const [selectedViewClassValue, setSelectedViewClassValue] = useState('0')
    const [selectedDegreeViewValue, setSelectedDegreeViewValue] = useState('0')
    const [selectedSpecificationViewValue, setSelectedSpecificationViewValue] = useState(null)
    
    const classViewRef = useRef()
    const [examHandlerValues, setExamHandlerValues] = useState({
        subject_id: '',
        degree_id: '',
        specialization_id: '',
        time_noon: '',
        startTime: '',
        endTime: '',
        year_id: '',
        date: ''
    });
   const { scheduleData, isLoading } = useSelector(
        (state) => state.scheduleState
        );
    const [finalData, setFinalData] = useState(null);
    const [timings, setTimings] = useState([]);
    const [endDate, setEndDate] = useState('');
    const [viewStartDate, setViewStartDate] = useState('');

    useEffect(() => {
   
      if (scheduleData) {
      let entries = Object.entries(scheduleData);
      console.log(entries,"entries");
      if (entries.length) {
        let columns = entries.length;
        let rows = Object.entries(entries[0][1]).length;
        let displayData = new Array(rows)
          .fill(0)
          .map((row) => new Array(columns).fill(0).map((col) => null));
        let col = 0;
        for (let dates in scheduleData) {
          for (let i = 0; i < 6; i++) {
            if (scheduleData[dates][`Session${i + 1}`]) {
            console.log([i][col],"i");
            if([i][col]!==undefined)
            {
                displayData[i][col] = scheduleData[dates][`Session${i + 1}`]; 
            }
                   //displayData[i][col] = scheduleData[dates][`Session${i + 1}`];  
            }
          }
          col++;
        }
        setFinalData(displayData);
        let days = [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ];
        let getDay = (date) => days[new Date(date).getDay()];
        let headerData = entries.map((date) => [
          date[0].split('-').reverse().join('-'),
          getDay(date[0]),
        ]);
        setHeaders(headerData);
        let timingsData = [
          '09:30 - 10:30',
          '11:00 - 12:00',
          '12:00 - 01:00',
          '02:00 - 03:00',
          '04:00 - 05:00',
          '05:00 - 06:00',
        ];
        setTimings(timingsData.slice(0, rows));
      } else {
        setFinalData([]);
      }
    }
  }, [scheduleData]);

 const getScheduleHandler = () => {
    if (selectedDegreeViewValue === '0') {
      alert('Please select a degree!');
      return;
    }
     if (selectedSpecificationViewValue === '0') {
      alert('Please select a degree!');
      return;
    }
    if (selectedViewClassValue === '0') {
      alert('Please select a class!');
      return;
    }
    if (selectedViewClassValue === '0') {
      alert('Please select a class!');
      return;
    }

    if (viewStartDate === '') {
      alert('Please select start date!');
      return;
    }
    if (endDate === '') {
      alert('Please select end date!');
      return;
    }

    let weekCheck =
      Date.parse(endDate.split('-').reverse().join('-')) -
        Date.parse(viewStartDate.split('-').reverse().join('-')) >=
      604800000;

    if (weekCheck) {
      alert('Please select a duration less than or equal to 7 days');
      return;
    }
    dispatch(
      loadSchedule(
        viewStartDate.split('-').reverse().join('-'),
        endDate.split('-').reverse().join('-'),
        selectedViewClassValue === '0' ? '1' : selectedViewClassValue,
        selectedDegreeViewValue,
        selectedSpecificationViewValue
      )
    );
  };


    const getNextSessionTime = (time) => {
        let newTime = Number(time.split(':').join('')) + 100
        let newTimeString = newTime.toString()
        if (newTimeString.length === 3) {
            newTimeString = '0' + newTimeString
        }
        newTimeString = newTimeString.substring(0, 2) + ':' + newTimeString.substring(2)
        return newTimeString
    }
 

    const changeHandler = () => {
        setSelectedValue(daysRef.current.value)
    }
    const classChangeHandler = () => {
        setSelectedClassValue(classRef.current.value)
    }

    const classViewChangeHandler = () => {
        setSelectedViewClassValue(classViewRef.current.value)
    }

    const degreeChangeHandler = () => {
        setSelectedDegreeValue(degreeRef.current.value)
    }

    const specificationChangeHandler = () => {
        setSelectedSpecificationValue(specRef.current.value)
    }
 
  

    const validSelection = (date) => {
        setStartDate(date)
    }

 

    useEffect(() => {
        dispatch(setHeaderText('Schedule'))
        dispatch(loadSubjects())
        dispatch(loadSessionTimings())
        dispatch(getClasses())
        dispatch(getDegrees())
        dispatch(getExamSchedules())
        // eslint-disable-next-line
    }, []);

 
 

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
            </Box>

           
            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between'   flexDirection="column" mb='2rem'>
           
                          
              <Box bg='white' borderRadius='20px' py='0.2rem'
                    pl='1rem' mt='1rem' pr='1rem' mb="2rem" boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'>
                            <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px',textTransform:"uppercase"  }}
                                
                            >
              <Box width='32%'>
                                <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                    >
                                        Degree
                                    </Text>
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'
                                        onChange={degreeChangeHandler}
                                        fontSize='18px'
                                        ref={degreeRef}
                                    >
                                        <option value='' key='-1'>Select Degree</option>
                                        {
                                            degreeState.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>

                                <Box width='32%'>
                                    <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif',textTransform:"uppercase"  }}
                                    >
                                        Specialization
                                    </Text>
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'
                                        ref={specRef}
                                        onChange={specificationChangeHandler}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Specialization</option>
                                        {
                                            specificationState.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>

                <Box width='35%'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Class
                  </Text>
                  <Select
                    id='type'
                    width={['100%', '100%', '90%', '95%']}
                    border='1px solid rgba(0, 0, 0, 0.1)'
                    borderRadius='13px'
                    height='40px'
                    ref={classViewRef}
                    value={selectedViewClassValue}
                    onChange={classViewChangeHandler}
                    fontSize='18px'
                  >
                    <option value='0' key='-1'>
                      Select a Class
                    </option>
                    {classesData.map((className, idx) => (
                      <option value={className.id} key={idx}>
                        {className.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                </Box>
                 <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='4rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px',textTransform:"uppercase"  }}
                                
                            >
                <Box width='40%' mr='1rem'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select Start Date
                  </Text>

                  <Flatpickr
                    value={viewStartDate}
                    options={{ dateFormat: 'd-m-Y' }}
                    placeholder='dd-mm-yyyy'
                   
                    onClick={(date, dateStr, instance) => {
                      setViewStartDate(dateStr);
                    }}
                    onChange={(date, dateStr, instance) => {
                      setViewStartDate(dateStr);
                    }}
                    style={{
                      padding: '1rem',
                      color: '#666666',
                      width: '100%',
                      height: '40px',
                      backgroundColor: 'transparent',
                      borderRadius: '13px',
                      border: '1px solid rgba(0, 0, 0, 0.1)',
                    }}
                  />
                </Box>

                <Box width='40%' mr='1rem'>
                  <Text
                    fontSize='16px'
                    fontWeight='700'
                    color='#999999'
                    mb='1rem'
                    style={{ fontFamily: 'Mulish, sans-serif',textTransform:'uppercase' }}
                  >
                    Select End Date
                  </Text>

                  <Flatpickr
                    value={endDate}
                    options={{ dateFormat: 'd-m-Y' }}
                    placeholder='dd-mm-yyyy'
                   onChange={(date, dateStr, instance) => {
                      setEndDate(dateStr);
                    }}
                    onClick={(date, dateStr, instance) => {
                      setEndDate(dateStr);
                    }}
                    style={{
                      padding: '1rem',
                      color: '#666666',
                      width: '100%',
                      height: '40px',
                      backgroundColor: 'transparent',
                      borderRadius: '13px',
                      border: '1px solid rgba(0, 0, 0, 0.1)',
                    }}
                  />
                </Box>

                <Box
                  height='100%'
                  d='flex'
                  justifyContent='center'
                  alignItems='flex-end'
                >
                  <Button
                    fontSize='16px'
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    colorScheme='messenger'
                    isLoading={isLoading}
                    loadingText='Fetching...'
                    onClick={getScheduleHandler}
                  >
                    Get Schedule
                  </Button>
                </Box>
              </Box>
                                              </Box>


              <Box width={['100%']} bg='white' borderRadius='20px' boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)' 
                    pl='1rem'  pr='2rem'  justifyContent='flex-start' alignItems='center' flexDir='column' d='flex' mb='2rem'>
                {finalData && finalData.length > 0 ? (
                   <Box w='100%' justifyContent='space-between' alignItems='center' d='flex' flexDir='column'>

                    {headers.length > 0 && (
                      <Box
                        width='100%'
                        display='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        borderRadius='20px'
                      >
                        <Box
                          flex='1'
                          height='100px'
                          display='flex'
                          flexDir='column'
                          justifyContent='center'
                          alignItems='center'
                          color='black'

                        >
                          <Text
                            fontStyle='normal'
          lineHeight='18px'
          fontSize='16px'
          fontWeight='700'
          color='black'
          style={{ fontFamily: 'Mulish, sans-serif'  }}
                          >
                            <b>Timings</b>
                          </Text>
                        </Box>
                        {headers.map((day, idx) => (
                          <Box
                            flex='1'
                            height='100px'
                            key={idx}
                            display='flex'
                            flexDir='column'
                            justifyContent='center'
                            alignItems='center'
                            color='black'
                            borderLeft='1px solid rgba(0, 0, 0, 0.1)'
                            borderBottom='1px solid rgba(0, 0, 0, 0.1)'
                          >
                            <Text
                              fontStyle='normal'
                      lineHeight='18px'
                      fontSize='16px'
                      fontWeight='700'
                      color='black'
                      style={{ fontFamily: 'Mulish, sans-serif'  }}
                            >
                              <b>{day[1]}</b>
                            </Text>
                            <Text
                              fontStyle='normal'
                      lineHeight='18px'
                      fontSize='16px'
                      fontWeight='700'
                      color='black'
                      style={{ fontFamily: 'Mulish, sans-serif'  }}
                            >
                              {day[0]}
                            </Text>
                          </Box>
                        ))}
                      </Box>
                    )}

                    {finalData &&
                      finalData.map((session, idx) => (
                        <ViewScheduleRow
                          key={idx}
                          id={idx}
                          session={session}
                          time={timings[idx]}
                        />
                      ))}
                  </Box>
                ) : (
                  <Box
                    w='100%'
                    justifyContent='space-between'
                    alignItems='center'
                    d='flex'
                    flexDir='column'
                  >
                    <Text>
                      No Schedule Available for selected Class/Date-Range
                    </Text>
                  </Box>
                )}
              </Box>
             
            </Box>




        </Box>
    )
}